import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Alert
} from '@mui/material';
import { useAuth } from '../../../components/auth/AuthContext';
import AdminTabs from '../../../components/admin/AdminTabs';
import TestHotelPicker from './TestHotelPicker';

export default function UtilitiesPage() {
  const navigate = useNavigate();
  const { currentUser, loadingUser } = useAuth();
  const [loading, setLoading] = useState(true);



  if (loadingUser) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!currentUser || currentUser.userType !== 'internal') {
    window.location.href = '/';
    return null;
  }

  return (
    <Box sx={{ minHeight: '100vh', py: 4, mt: 8 }}>
      <Container maxWidth="lg">
        <AdminTabs currentPath="/admin/utilities" />
        
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4 }}>
          Utilities
        </Typography>
        
        <TestHotelPicker />
      </Container>
    </Box>
  );
}